import { defineComponent as _defineComponent } from 'vue'
import FarmFireRiskChart from './FarmFireRiskChart.vue'
import Tooltip from '@/components/ui/tooltip/Tooltip.vue'
import FarmFireRiskChartTooltipFactory from './FarmFireRiskChartTooltip.factory.vue'
import { RecentFireRisk } from '@/@core/fire-risk-dashboard/domain/entities/RecentFireRisk'


export default /*#__PURE__*/_defineComponent({
  __name: 'FarmFireRiskChartCard',
  props: {
    farm: null
  },
  setup(__props: any) {



return { __sfc: true,FarmFireRiskChart, Tooltip, FarmFireRiskChartTooltipFactory }
}

})